<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    class="temporary-position"
    @click="mainAction()"
  >
    <md-card
      @click="mainAction()"
      class="snew-arrival-card"
      :class="[{ 'md-elevation-20': mouseEnter }]"
    >
      <div class="card-header">
        <md-avatar class="little-header-avatar">
          <img src="../../../public/img/little-header-icons/swampum-system-header.png" alt="Group" />
        </md-avatar>
        <span class="md-title">New user joined</span>
        <img src="../../../public/img/user-card-header.png" alt="card-header-img" class="card-header-image" />
      </div>
      <md-card-header class="arrival-card-header">
        <router-link :to="`/s-app/profile-page/${arrival.user.id}/`">
          <SUserAvatar
            :myUser="arrival.user"
            size="small"
            :isProfileAvatar="false"
          />
        </router-link>

        <div class="arrival-header-content">
          <div class="md-title">
            <div class="name-content">
              <router-link :to="`/s-app/profile-page/${arrival.user.id}/`">
                <div class="author-name">{{ arrival.user.firstName }}</div>
              </router-link>
              <div class="username">@{{ arrival.user.username }}</div>
            </div>
          </div>
          <div class="md-subhead">
            Joined <span class="arrival-date">{{ getJoinedDate(arrival.user.createdAt) }}</span>
          </div>
        </div>
      </md-card-header>

      <md-card-content class="welcome-content">
        <div class="group-text">
          <span class="user-infos">
            <span class="bold-text"> ZIP code: </span>
            {{ arrival.user.zip }}
          </span>
          <span class="user-infos">
            <span class="bold-text"> City: </span>
            {{ arrival.user.city }}
          </span>
          <div
            id="user-description"
            v-if="
              arrival.user.description !== null &&
              arrival.user.description !== ''
            "
          >
            <p id="description-text">
              <span class="bold-text">About: </span>
              {{ arrival.user.description }}
            </p>
          </div>
          <div id="user-description" v-else>
            <p id="description-text">
              <span class="bold-text">About: </span>
              No info.
            </p>
          </div>
        </div>

        <div class="group-connection">
          <router-link :to="`/s-app/profile-page/${arrival.user.id}/`">
            <SUserAvatar
              :myUser="arrival.user"
              size="large"
              :isProfileAvatar="false"
            />
          </router-link>
          <md-icon class="ml-2 mr-2">link</md-icon>
          <router-link :to="`/s-app/profile-page/${arrival.user.id}/`">
            <SSwampumAvatar size="large" class="swampum-avatar" />
          </router-link>
        </div>

        <div class="group-text">
          <span>
            Welcome,
            <router-link :to="`/s-app/profile-page/${arrival.user.id}`">
              <span class="highlighted-word">
                {{ arrival.user.firstName }}!
              </span>
            </router-link>
          </span>
        </div>
        <div class="profile-button">
          <SButtonViewProfile
            v-if="!isLoggedUser"
            dataCy="btnViewProfile_result"
            text="View Profile"
            icon="account_circle"
            class="view-profile-button"
            @setAction="mainAction()"
          />
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment";
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import SSwampumAvatar from "@/material-components/atoms/SSwampumAvatar";
import SButtonViewProfile from "@/material-components/molecules/SButtonViewProfile.vue";
export default {
  name: "SNewArrivalMaterial",
  props: ["arrival"],
  mixins: [UserHelperVue, GroupHelperVue],
  data() {
    return {
      mouseEnter: false,
    };
  },
  components: {
    SUserAvatar,
    SSwampumAvatar,
    SButtonViewProfile,
  },
  methods: {
    mainAction() {
      this.$router.push(`/s-app/profile-page/${this.arrival.user.id}/`);
    },
    getTimeAgo(time) {
      if (time) {
        return moment(time).fromNow();
      } else {
        return "";
      }
    },
    getJoinedDate(time) {
      if (time) {
        return moment(time).format("MM/DD/YY");
      } else {
        return "";
      }
    },
    openChat() {
      this.$emit("openWindowPopup");
    },
  },
  computed: {
    isLoggedUser() {
      return this.arrival.user.id === this.loggedUser.id;
    },
  },
};
</script>

<style>
.profile-button .view-profile-btn {
  min-width: 230px;
}

.profile-button .view-profile-btn .md-ripple {
  width: unset;
}
</style>

// default card size
<style lang="scss" scoped>
.view-profile-button {
  margin-top: 40px;
}

.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}

.snew-arrival-card {
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 558px;
  color: $black !important;
  border-radius: 4px;
  border: 1px solid $grey;
  display: flex;
  flex-direction: column;
}
.welcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-button {
  display: flex;
  flex-direction: row;
  margin-top: 1.3rem;
}
.group-connection {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.welcome-action-user,
.group-text {
  word-break: break-all;
}
.group-connection i {
  color: $black !important;
}
.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}
.highlighted-word,
.self-highlighted-word {
  font-weight: bold;
}
.highlighted-word {
  overflow: hidden;
  width: 275px;
  color: $tertiary;
}
.group-text {
  text-align: center;
  color: $black;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.25px;
}
.md-title a {
  color: $black;
  height: 20px;
}
.md-title a:hover {
  color: $primary;
}
.welcome-action-user i {
  color: $primary !important;
}
.open-chat {
  cursor: pointer;
  color: $tertiary;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-align: center;
}
.open-chat:hover {
  color: $primary;
}
.send-msg-item-btn {
  margin-left: -43px;
}
@media screen and (max-width: 560px) {
  .temporary-position {
    display: flex;
    justify-content: center;
  }
  .md-large {
    width: 80px !important;
    height: 80px !important;
    min-width: 80px !important;
    min-height: 80px !important;
  }
}
.name-content {
  display: flex;
  flex-direction: column;
}
.arrival-card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  align-content: center;
  max-width: 250px;
}
.arrival-date {
  font-weight: bold;
}
.author-name {
  color: $black;
  font-size: 0.875rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.arrival-header-content {
  max-width: 90%;
}
.username {
  font-size: 11px;
  color: #c4c4c4;
  font-weight: normal;
  height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: -3px 0 4px 0;
}
.md-subhead {
  opacity: unset;
}
.swampum-avatar {
  border-radius: 0;
}
.user-infos {
  color: $black !important;
  opacity: 0.6;
  font-size: 16px;
  margin-top: 0.35rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}
.bold-text {
  font-weight: bold;
  color: $black;
}
#user-description {
  overflow: hidden;
  width: 240px;
  height: 70px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  border: 0 !important;
  color: $dark;
  word-break: break-word;
  text-align: justify;
  margin-top: 0.25rem;
  opacity: 0.6;
}
#description-text {
  color: $black !important;
  font-size: 14px;
}
.md-button {
  min-width: 0;
}
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
  margin-top: 5px;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 75%;
}
.little-header-avatar {
  border-radius: 0;
  background-color: #B40028 !important;
}
</style>
